import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './containers/App';
import NotFoundPage from './components/NotFoundPage';
import ProposalsPage from './containers/ProposalsPage';
import ProposalPage from './containers/ProposalPage';
import ViewProposalPage from './containers/ViewProposalPage';
import CompletedPage from './containers/CompletedPage';

export default (
    <Route path="/" component={App}>
        <IndexRoute component={ProposalsPage}/>
        <Route path="/completed" component={CompletedPage}/>
        <Route path="/edit(/:Id)" component={ProposalPage}/>
        <Route path="/view/:Id" component={ViewProposalPage}/>
        <Route path="*" component={NotFoundPage}/>
    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js